var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-toast',{attrs:{"id":_vm.idToast,"variant":_vm.variant,"solid":""}},[_c('div',{staticClass:"d-flex flex-grow-1 align-items-baseline",attrs:{"slot":"toast-title"},slot:"toast-title"},[_c('strong',{staticClass:"mr-auto"},[_vm._v(_vm._s(_vm.titleMsg))])]),_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76b25c5d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/toastVue.vue
// module id = TwnM
// module chunks = 1